import { IRequestDetails } from '../common';
import { pathOr } from 'rambda';
import { find as lfind, compose as lcompose, getOr as lgetOr } from 'lodash/fp';

export const justificationOptions = {
  ENROLL: [],
  RENEWAL: [],
  REVOKE: [
    { value: '', label: '(Empty)' },
    { value: 'E. Affiliation Change', label: 'Affiliation Change' },
    { value: 'F. CA Compromise', label: 'CA Compromise' },
    { value: 'H. Cessation of Operation', label: 'Cessation of Operation' },
    { value: 'J. Key Compromise', label: 'Key Compromise' },
    { value: 'K. Superseded', label: 'Superseded' },
    { value: 'Other', label: 'Other' },
  ],
};

export const requestorComments =
  (reqType: 'ENROLL' | 'RENEWAL' | 'REVOKE') =>
  (previousRequest: IRequestDetails | undefined) =>
    pathOr(null, 'reqType')(previousRequest) === reqType
      ? pathOr(null, 'requestorComments')(previousRequest)
      : null;

export const requestorCommentsOfRevoke = (value: string) =>
  lcompose(
    lgetOr('Other', 'value'),
    lfind<{ value: string; label: String }>({ value })
  )(justificationOptions.REVOKE);
